<template>
  <q-btn
          v-if="isGranted('DELETE_PAYMENT_METHOD')"
          icon="fa fa-times"
          title="Delete Payment Method"
          v-bind="$attrs"
          @click="openModal"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import isGranted from '@/auth/isGranted';
import { PaymentMethod } from '@/type';
import openModal from '@/components/modal';
import DeletePaymentMethodModal from './DeletePaymentMethodModal.vue';

export default defineComponent({
  emits: ['deleted'],
  props: {
    paymentMethod: {
      type: Object as () => PaymentMethod,
      required: true,
    },
  },
  methods: {
    openModal() {
      const props = { paymentMethod: this.paymentMethod, parent: this };
      openModal(DeletePaymentMethodModal, props).onOk(() => {
        this.$emit('deleted');
      });
    },
    isGranted,
  },
});
</script>
